import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { changeProfileModalState } from "../../redux/employees/loggedEmployeeActions";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import "./ProfileModal.css";
import Typography from "@mui/material/Typography";
import { withStyles } from "@mui/styles";
import CustomizedTextField from "../Input/CustomizedTextField";

const styles = {
	appBar: {
		position: "relative",
	},
	flex: {
		flex: 1,
	},
};

class ProfileModal extends Component {
	shouldComponentUpdate(nextProps) {
		if (!nextProps.loggedEmployee || !this.props.loggedEmployee) return false;

		return (
			nextProps.loggedEmployee.loggedEmployee !==
				this.props.loggedEmployee.loggedEmployee ||
			nextProps.loggedEmployee.profileModalOpened !==
				this.props.loggedEmployee.profileModalOpened
		);
	}

	handleClose = () => {
		this.props.changeProfileModalState(false);
	};

	render() {
		const { classes } = this.props;

		if (!this.props.loggedEmployee || !this.props.loggedEmployee.loggedEmployee)
			return <div></div>;

		let loggedEmployee = this.props.loggedEmployee.loggedEmployee;

		return (
			<div>
				<Dialog
					fullScreen={true}
					open={this.props.loggedEmployee.profileModalOpened}
					onClose={this.handleClose}
					aria-labelledby="form-dialog-title"
				>
                    <AppBar className={classes.appBar} elevation={0}>
                        <Toolbar>
                            <IconButton
                                color="inherit"
                                onClick={this.handleClose}
                                aria-label="Close"
                            >
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" color="inherit">
                                {loggedEmployee.first_name + " " + loggedEmployee.last_name}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <Toolbar/>
					<DialogContent>
						<div className="row col-lg-12 col-md-12 col-sm-12 col-12">
							<div className="fieldset-margin-top col-lg-6 col-md-6 col-sm-12 col-12">
								<Typography variant="h6">Informations principales</Typography>
								<CustomizedTextField
									value={loggedEmployee.sage_ref}
									id="matricule"
									label={"Matricule"}
									className="full_size light-disabled control-margin-top"
								/>
								<CustomizedTextField
									value={loggedEmployee.internal_number}
									id="internal_number"
									label={"Code employé"}
									className="full_size light-disabled control-margin-top"
								/>
								<CustomizedTextField
									value={loggedEmployee.department_id.name}
									id="department"
									label={"Filière"}
									className="full_size light-disabled control-margin-top"
								/>
							</div>
							<div className="fieldset-margin-top col-lg-6 col-md-6 col-sm-12 col-12">
								<Typography variant="h6">Agence</Typography>
								<CustomizedTextField
									value={loggedEmployee.company_id.name}
									id="company-name"
									label={"Nom"}
									className="full_size light-disabled control-margin-top"
								/>
								{loggedEmployee.company_id.phone ? (
									<div className="col-lg-12 col-md-12 col-sm-12 col-12">
										<a
											href={"tel:" + loggedEmployee.company_id.phone}
											className="full_size control-margin-top"
										>
											{"Téléphone: " + loggedEmployee.company_id.phone}
										</a>
									</div>
								) : (
									<div></div>
								)}
								<CustomizedTextField
									value={loggedEmployee.company_id.capacity_certificate}
									id="company-capacity-certificate"
									label={"Attestation de capacité"}
									className="full_size light-disabled control-margin-top"
								/>
								<CustomizedTextField
									value={loggedEmployee.company_id.address}
									id="company-address"
									multiline
									label={"Adresse"}
									className="full_size light-disabled control-margin-top"
								/>
							</div>
						</div>
						<div className="row col-lg-12 col-md-12 col-sm-12 col-12">
							<div className="fieldset-margin-top col-lg-6 col-md-6 col-sm-12 col-12">
								<Typography variant="h6">{"Responsable N + 1"}</Typography>
								<CustomizedTextField
									value={
										loggedEmployee.manager_n1_id &&
										loggedEmployee.manager_n1_id.name
									}
									id="manager1-name"
									label={"Nom"}
									className="full_size light-disabled control-margin-top"
								/>
								{loggedEmployee.manager_n1_id &&
								loggedEmployee.manager_n1_id.work_phone ? (
									<div className="col-lg-12 col-md-12 col-sm-12 col-12">
										<a
											href={"tel:" + loggedEmployee.manager_n1_id.work_phone}
											className="full_size control-margin-top"
										>
											{"Bureau: " + loggedEmployee.manager_n1_id.work_phone}
										</a>
									</div>
								) : (
									<div></div>
								)}
								{loggedEmployee.manager_n1_id &&
								loggedEmployee.manager_n1_id.mobile_phone ? (
									<div className="col-lg-12 col-md-12 col-sm-12 col-12">
										<a
											href={"tel:" + loggedEmployee.manager_n1_id.mobile_phone}
											className="full_size control-margin-top"
										>
											{"Portable: " + loggedEmployee.manager_n1_id.mobile_phone}
										</a>
									</div>
								) : (
									<div></div>
								)}
							</div>
							<div className="fieldset-margin-top col-lg-6 col-md-6 col-sm-12 col-12">
								<Typography variant="h6">{"Responsable N + 2"}</Typography>
								<CustomizedTextField
									value={
										loggedEmployee.manager_n2_id &&
										loggedEmployee.manager_n2_id.name
									}
									id="manager2-name"
									label={"Nom"}
									className="full_size light-disabled control-margin-top"
								/>
								{loggedEmployee.manager_n2_id &&
								loggedEmployee.manager_n2_id.work_phone ? (
									<div className="col-lg-12 col-md-12 col-sm-12 col-12">
										<a
											href={"tel:" + loggedEmployee.manager_n2_id.work_phone}
											className="full_size control-margin-top"
										>
											{"Bureau: " + loggedEmployee.manager_n2_id.work_phone}
										</a>
									</div>
								) : (
									<div></div>
								)}
								{loggedEmployee.manager_n2_id &&
								loggedEmployee.manager_n2_id.mobile_phone ? (
									<div className="col-lg-12 col-md-12 col-sm-12 col-12">
										<a
											href={"tel:" + loggedEmployee.manager_n2_id.mobile_phone}
											className="full_size control-margin-top"
										>
											{"Portable: " + loggedEmployee.manager_n2_id.mobile_phone}
										</a>
									</div>
								) : (
									<div></div>
								)}
							</div>
						</div>

						<div className="row col-lg-12 col-md-12 col-sm-12 col-12">
							<div className="fieldset-margin-top col-lg-6 col-md-6 col-sm-12 col-12">
								<Typography variant="h6">Détecteur de fuite</Typography>
								<CustomizedTextField
									value={loggedEmployee.leak_detector_brand}
									id="leak_detector_brand"
									label={"Marque"}
									className="full_size light-disabled control-margin-top"
								/>
								<CustomizedTextField
									value={loggedEmployee.leak_detector_model}
									id="leak_detector_model"
									label={"Modèle"}
									className="full_size light-disabled control-margin-top"
								/>
								<CustomizedTextField
									value={loggedEmployee.leak_detector_identification}
									id="leak_detector_identification"
									label={"Identifiant"}
									className="full_size light-disabled control-margin-top"
								/>
								<CustomizedTextField
									value={loggedEmployee.leak_detector_last_check_date}
									id="leak_detector_last_check_date"
									label={"Dernière vérification"}
									className="full_size light-disabled control-margin-top"
								/>
							</div>
						</div>
					</DialogContent>
				</Dialog>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		loggedEmployee: state.loggedEmployee,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		changeProfileModalState: (profileModalOpened) =>
			dispatch(changeProfileModalState(profileModalOpened)),
	};
};

export default compose(
	withRouter,
	withStyles(styles),
	connect(mapStateToProps, mapDispatchToProps)
)(ProfileModal);
